import React from "react";
import { ArrowRight, Check } from "lucide-react";
import { Button } from "../ui/button";

const FeeList = ({ items, testId, className }) => (
  <ul className={className} data-testid={testId}>
    {items.map((item, index) => (
      <li key={item} data-testid={`${testId}-${index}`}>
        <Check aria-hidden="true" />
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

export const ModelFeeCard = ({ price, onBook }) => (
  <aside id="precio" className="model-fee-card scroll-mt-28" aria-labelledby="model-fee-label" data-testid="model-fee-card">
    <p id="model-fee-label" className="model-fee-label" data-testid="model-fee-label">{price.label}</p>
    <div className="model-fee-price" data-testid="model-fee-price">
      <span className="model-fee-amount" data-testid="model-fee-amount">{price.amount}</span>
      <span className="model-fee-period" data-testid="model-fee-period">{price.per}</span>
    </div>
    <FeeList items={price.checks} className="model-fee-checks" testId="model-fee-checks" />
    <div className="model-fee-included">
      <h3 data-testid="model-fee-includes-title">{price.includesTitle}</h3>
      <FeeList items={price.includes} className="model-fee-includes" testId="model-fee-includes" />
    </div>
    <Button type="button" className="model-fee-cta" onClick={onBook} data-testid="model-fee-cta">
      <span data-testid="model-fee-cta-label">{price.cta}</span>
      <ArrowRight aria-hidden="true" />
    </Button>
  </aside>
);